angular
    .module('satv.search')
    .controller('SearchCtrl', ['$scope', 'searchLoader', 'Search', 'SearchConfig', '$location', function ($scope, searchLoader, Search, SearchConfig, $location) {
        //First detect whether we need to initiate a new search or whether we can
        //base our search on the search config still present in the SearchConfig service.
        if (Object.keys($location.search()).length === 0 &&
            SearchConfig.getModel()
        ) {
            //no search params are present,.. navigate to previous search
            SearchConfig.apply();
        } else {
            //init a new one
            Search.init(searchLoader);
        }

        $scope.searchLoader = searchLoader.getFirstPage();
        $scope.searchConfig = SearchConfig;
        $scope.searchModel = SearchConfig.getModel();

        /**
         * @param  {Object} params
         */
        $scope.search = function () {
            SearchConfig.apply();
        };

        /**
         * Sort the result
         */
        $scope.sortBy = function (fieldName, defaultOrder) {
            if (fieldName) {
                var sortOrder = defaultOrder || 'ASC';

                if (SearchConfig.isset('sortBy', fieldName)) {
                    sortOrder = SearchConfig.isset('sortOrder', 'DESC') ? 'ASC' : 'DESC';
                }

                SearchConfig.set({
                    'sortBy': fieldName,
                    'sortOrder': sortOrder
                });
            } else {
                SearchConfig.set({
                    'sortBy': null,
                    'sortOrder': null
                });
            }
        };
    }]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/Resources/js/angular/controllers/SearchCtrl.js